import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteBusinessCase, setActiveBusinessCase } from '../../views/business-case/business-case.actions';
import BusinessCasesListView from './business-cases-list.presenter';

export const mapStateToProps = state => ({
  authorableText: state.authorableContentReducer.authorableContent.myBusinessCases.businessCaseList,
  bcbCasesList: state.businessCaseReducer.businessCaseList,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteBusinessCase,
    setActiveBusinessCase,
  }, dispatch),
});

const BusinessCasesList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusinessCasesListView);

export default BusinessCasesList;
